import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type activationOrdersType = {
  companyId?: string;
  showDeleted?: boolean;
  errorCallback: Function;
  resultKey: string;
};

export default ({
  companyId = '',
  showDeleted = false,
  errorCallback,
  resultKey = 'activationOrdersData',
}: activationOrdersType) =>
  requestAsync({
    url: endpoints.getActivationOrdersUrl(companyId, showDeleted),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrdersUrl(companyId, showDeleted),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
